import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsAnalyticsDataViewDetailsRoute: InvariantJiraRoute = {
	name: 'assets-analytics-data-view-details',
	path: '/jira/assets/analytics/data-view/:dataViewId',
	exact: true,
};
